export default __webpack_public_path__ + "static/media/NoticeIcon.b308a46a.svg";